import { toAnalyticsItems } from "~/sdk/ga4/transform/toAnalyticsItems"
import { getTotalValue } from "~/sdk/ga4/transform/getTotalValue"
import type { AnalyticsView, ProductItem } from "~/sdk/ga4/types/index"

export interface ToAddToWishlist {
    type?: 'add_to_wishlist'
    items: ProductItem[]
    view: AnalyticsView
}

export const toAddToWishlist = (data: ToAddToWishlist) => {
    const items = toAnalyticsItems({ items: data.items, view: data.view })
    const value = getTotalValue(items)

    return {
        name: 'add_to_wishlist' as const,
        params: {
            currency: data.items[0]?.extended?.currency ?? 'BRL',
            value,
            items,
        },
    }
}
